import React from 'react';
import * as Opt from '../editor/Helpers';
import ColorSelector from '../editor/fields/ColorSelector';

class Metrics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const h2Class = 'text-[39px] leading-[1.01] tracking-[-1.17px] lg:text-[76px] lg:leading-[100%] lg:tracking-[-2.28px] font-bold'
    return (
      <div className={`${window.location.pathname.includes('editor') && (["dt", "mob"].filter((i) => i === this.props.visibility).length) ? 'opacity-50' : this.props.visibility == "dt" ? 'hidden lg:block' : this.props.visibility == "mob" ? 'lg:hidden' : ''} bg-${this.props.backgroundColor}`}>
        <div className='container'>
            <div className="flex flex-wrap justify-center flex-col lg:flex-row ">
                <div className="w-1/3">
                  <h2 className={`${h2Class} ${this.props.fontColor}`}>23%</h2>
                  <p className={`fs-5 mb-[30px] ${this.props.fontColor}`}>Högre virkespris</p>
                </div>
                <div className="w-1/3">
                  <h2 className={`${h2Class} ${this.props.fontColor}`}>1500+</h2>
                  <p className={`fs-5 mb-[30px] ${this.props.fontColor}`}>Virkesköpare</p>
                </div>
                <div className="w-1/3">
                  <h2 className={`${h2Class} ${this.props.fontColor}`}>65,000+</h2>
                  <p className={`fs-5 mb-[30px] ${this.props.fontColor}`}>Medlemmar</p>
                </div>
            </div>
          </div>
        </div>
    )
  }
}

Metrics.defaultProps = {
  visibility: "",
  backgroundColor: 'white-50',
  fontColor: 'neutral-charcoal',
  spacing: [],
}

Metrics.fields = {
  backgroundColor: {
    type: "custom",
    render: (props) => <ColorSelector {...props} />
  },
  visibility: {
    type: "select",
    options: Opt.visibilityOptions
  },
  fontColor: {
    type: "select",
    options: Opt.colorVariables
  }
}

export default Metrics;